module.exports = __webpack_public_path__ + "images/9ef3d643c74c9c70daa1e495b0bf124f.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/wheels-characters02.jpg
// module id = ./webpack/assets/img/wheels-characters02.jpg
// module chunks = 0